import registerColumn from '../../../common/columns/index';
import presentationalComponent from './ColumnPresentationalWrapper';
import containerComponent from './ColumnContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerColumn({
        presentationalComponent,
        containerComponent,
        tools: [TOOLS.COLOR],
        tooltip: isApple ? '⌃⌘G' : 'Ctrl+Alt+G',
        selectedTools: [TOOLBAR_TOOLS.COLOR, ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT],
    });
